import { Star, Quote } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const REVIEWS = [
    {
        name: "Ananya S.",
        trip: "Kerala Backwaters",
        text: "Every detail was handled — the houseboat, the meals, the timing. We just showed up and enjoyed. It felt like travelling with family who had planned everything.",
    },
    {
        name: "Rohit & Meera",
        trip: "Royal Rajasthan",
        text: "The heritage stays were breathtaking and the itinerary had room to breathe. Transparent pricing from the first call, exactly as promised.",
    },
    {
        name: "Vikram T.",
        trip: "Himachal Escape",
        text: "A driver, a plan and a phone number that always answered. The mountain leg had a landslide delay and the team rerouted us within minutes. Impressive.",
    },
];

export const Testimonials = () => (
    <section className="py-24 lg:py-32" data-testid="testimonials-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeading
                eyebrow="Guest Stories"
                title="Journeys our guests remember"
                description="Words from travellers who explored India with Vistaaryatra."
                align="center"
            />
            <div className="mt-16 grid gap-6 md:grid-cols-3">
                {REVIEWS.map((review, i) => (
                    <Reveal key={review.name} delay={i * 0.1} className="h-full">
                        <figure className="card-frame flex h-full flex-col p-8">
                            <Quote className="h-7 w-7 text-brass" fill="currentColor" strokeWidth={0} />
                            <div className="mt-4 flex gap-1" aria-label="5 star rating">
                                {[...Array(5)].map((_, s) => (
                                    <Star key={s} className="h-4 w-4 text-brass" fill="currentColor" strokeWidth={0} />
                                ))}
                            </div>
                            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-steel">
                                {review.text}
                            </blockquote>
                            <figcaption className="mt-6 border-t border-border pt-4">
                                <span className="block font-serif text-lg font-semibold text-navy" data-testid={`testimonial-name-${i}`}>
                                    {review.name}
                                </span>
                                <span className="text-xs uppercase tracking-[0.2em] text-brass-dark">{review.trip}</span>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
